import axios from "../lib/axios";
import { API_WEB } from "../utils/constants";

const csrf = () => axios.get("/sanctum/csrf-cookie");

// Start Quize
export async function startQuiz({ courseId, lectureId, quizId }) {
  await csrf();

  const response = await axios.get(
    `${API_WEB}/courses/${courseId}/lectures/${lectureId}/items/${quizId}/quiz`
  );

  if (response.status !== 200) {
    throw new Error(response.response.data.message);
  }
  return response.data;
}

// Quiz attempt data
export async function continueQuiz({ courseId, lectureId, quizId, attemptId }) {
  await csrf();

  const response = await axios.get(
    `${API_WEB}/courses/${courseId}/lectures/${lectureId}/items/${quizId}/attempts/${attemptId}/continueQuiz`
  );

  if (response.status !== 200) {
    throw new Error(response.response.data.message);
  }
  return response.data;
}

//Submit-Quiz answers
export async function submitQuiz({ answers, courseId, lectureId, quizId, attemptId }) {
  await csrf();

  const response = await axios.post(
    `${API_WEB}/courses/${courseId}/lectures/${lectureId}/items/${quizId}/attempts/${attemptId}/submitQuiz`,
    { answers }
  );

  if (response.status !== 200) {
    throw new Error(response.response);
  }
  return response.data;
}
